import { MfaQrCode } from '@/components/auth/mfaQrCode';
import { MfaVerificationCodeForm } from '@/components/auth/mfaVerificationCodeForm';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { routes } from '@/types/routes';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/(first-login)/setup-mfa')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (!context.auth.username || !context.auth.loginSession) {
      redirect({
        to: routes.firstTimeLogin,
        replace: true,
        throw: true,
      });
    }
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('setupMfa.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          <Trans i18nKey="setupMfa.description" ns="auth" components={ { bold: <span className="font-semibold" /> } } />
        </CardDescription>
      </CardHeader>

      <CardContent>
        <MfaQrCode />
        <MfaVerificationCodeForm />
      </CardContent>
    </>
  );
}
